/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react"; 
import { useNavigate,Link } from 'react-router-dom';

import backPageImage from "../../img/icon/icon-arrow-left.svg";
import calendarIcon from "../../img/icon/icon-stroke-calendar.svg"

const HeaderTitle = ({ varPageTitle,varBackString }) => {
  const navigate = useNavigate();
  
  //백페이지
  const onGotoBackpageHandler = () => {
    //console.log('back',varBackString);
    if(varBackString === undefined || varBackString === null || varBackString === "") navigate(-1);
    else if(varBackString === "none" || varBackString === "delivery") return false;
    else navigate(varBackString);
  }

  useEffect(() => {
    //페이지 크기 재설정
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content-head mb25 sticky">
      {varBackString !== "none" && varBackString !== "delivery"?
        <button id="head-back" className="his-back left" title="이전 페이지로" onClick={onGotoBackpageHandler}>
          <img src={backPageImage} alt="" />
        </button>
      :null}
      <h1 className="page-title">{varPageTitle}</h1>
      {varBackString==="delivery"?<Link to="/DeliveryHistory" className="page-hd-btn right"><img src={calendarIcon} alt="" /><span>운행일지</span></Link>:null}
    </div>
  );
}
export default HeaderTitle;